import React, {Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useAlert } from 'react-alert';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import { useDispatch, useSelector } from 'react-redux';
import { getContactus, deleteContactusData } from '../../../actions/adminContactusActions';
//import { deleteUserData } from '../../../actions/commonActions';

import Loader from "../../Loader";
// import Loader from "react-loader-spinner";

const ITEMS_PER_PAGE = 10;

const ListContactus = ({ history }) => {

    // const [users, setUsersData] = useState({});
    const alert = useAlert();
    const dispatch  = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [sourceFilter, setSourceFilter] = useState('all');

    
    
    useEffect(() => {
        dispatch(
            getContactus()
        )
    }, [dispatch]);

    const { contactusList, user_loading } = useSelector(state => state);

    // Practice leads only carry email, phone and exam type, so the contact-form
    // columns are dropped to keep that view readable.
    const isLeadView = sourceFilter === 'landing-practice';

    const allItems = (contactusList?.contactus || []).filter((item) => {
        if (sourceFilter === 'all') return true;
        if (sourceFilter === 'landing-practice') return item.source === 'landing-practice';
        return item.source !== 'landing-practice';
    }).slice().sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return dateB - dateA;
    });
    const totalPages = Math.ceil(allItems.length / ITEMS_PER_PAGE);
    const paginatedItems = allItems.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let end = Math.min(totalPages, start + maxVisible - 1);
        if (end - start + 1 < maxVisible) {
            start = Math.max(1, end - maxVisible + 1);
        }
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    const handleDeleteContactus = (id) => {
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        dispatch(deleteContactusData(id));
                        alert.success('Contact us deleted successfully');
                        dispatch(getContactus());
                        window.location.reload();
                    }
                },
                {
                    label: 'No',
                    onClick: () => alert.success('No data deleted')
                }
            ]
        });
    }

    return (
        <Fragment>
            {user_loading ? (
                <Loader />
            ) : (
                <Fragment>
                    <div className="content-wrapper">
                        <section className="content-header">
                            <h1>
                                Manage
                                <small> Contact Us</small>
                            </h1>
                            <ol className="breadcrumb">
                                <li><Link to="/admin"><i className="fa fa-dashboard"></i> Dashboard</Link></li>
                                <li className="active">Contact Us</li>
                            </ol>
                        </section>

                        <section className="content">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="box">
                                        <div className="box-header">
                                            <h3 className="box-title">Contact Us</h3>
                                            <div className="pull-right" style={{ lineHeight: "30px" }}>
                                                {allItems.length > 0 && (
                                                    <span style={{ color: "#888", marginRight: "10px" }}>
                                                        Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1}–{Math.min(currentPage * ITEMS_PER_PAGE, allItems.length)} of {allItems.length}
                                                    </span>
                                                )}
                                                <select
                                                    className="form-control input-sm"
                                                    style={{ display: "inline-block", width: "auto" }}
                                                    value={sourceFilter}
                                                    onChange={(e) => {
                                                        setSourceFilter(e.target.value);
                                                        setCurrentPage(1);
                                                    }}
                                                >
                                                    <option value="all">All contacts</option>
                                                    <option value="landing-practice">Free Practice leads (demo)</option>
                                                    <option value="contact-form">Contact form messages</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="box-body table-responsive no-padding">
                                            <table className="table table-hover">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Date & Time</th>
                                                    {!isLeadView && <th>Name</th>}
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Exam Type</th>
                                                    {!isLeadView && <th>Source</th>}
                                                    {!isLeadView && <th>Subject</th>}
                                                    {!isLeadView && <th>Message</th>}
                                                    {!isLeadView && <th>Is Replied</th>}
                                                    <th>Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {contactusList.user_loading ? <Loader /> : ((paginatedItems.length)? paginatedItems.map((catItem, index) => (
                                                    <tr key={catItem._id}>
                                                        <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                                                        <td style={{ whiteSpace: 'nowrap' }}>{catItem.createdAt ? new Date(catItem.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : '-'}</td>
                                                        {!isLeadView && <td>{catItem.firstName || '-'}</td>}
                                                        <td>{catItem.email}</td>
                                                        <td style={{ whiteSpace: 'nowrap' }}>{catItem.mobileNo || '-'}</td>
                                                        <td>{catItem.examType || '-'}</td>
                                                        {!isLeadView && (
                                                        <td>
                                                            {catItem.source === 'landing-practice' ? (
                                                                <span className="badge bg-blue">Free Practice</span>
                                                            ) : (
                                                                <span className="badge bg-gray">Contact Form</span>
                                                            )}
                                                        </td>
                                                        )}
                                                        {!isLeadView && <td>{catItem.subject}</td>}
                                                        {!isLeadView && <td>{catItem.message && catItem.message.length > 50 ? catItem.message.substring(0, 50) + "..." : catItem.message}</td>}
                                                        {!isLeadView && (
                                                        <td>
                                                            {catItem.isReply === true && (
                                                                <span className="badge bg-green">Yes</span>
                                                            )}
                                                            {catItem.isReply === false && (
                                                                <span className="badge bg-yellow">No</span>
                                                            )}
                                                        </td>
                                                        )}
                                                        <td>
                                                            <Link to={`/admin/contactus/detail/${catItem._id}`} className="btn btn-success btn-sm" title="View" ><i className="fas fa-eye"></i></Link>
                                                            &nbsp;
                                                            <a className="btn btn-danger btn-sm"
                                                               title="Delete"
                                                               onClick={() => handleDeleteContactus(catItem._id)}
                                                               key={catItem._id}
                                                               style={{ cursor: "pointer" }}
                                                            ><i className="fas fa-trash-alt"></i></a>
                                                        </td>
                                                    </tr>
                                                )): <tr>
                                                    <td colSpan={isLeadView ? 6 : 11}>
                                                        No records found
                                                    </td>
                                                </tr>)}

                                                </tbody>
                                                <tfoot>
                                                </tfoot>
                                            </table>
                                        </div>
                                        {/* Pagination */}
                                        {totalPages > 1 && (
                                            <div className="box-footer clearfix">
                                                <ul className="pagination pagination-sm no-margin pull-right">
                                                    <li className={currentPage === 1 ? "disabled" : ""}>
                                                        <a onClick={() => goToPage(1)} style={{ cursor: "pointer" }}>
                                                            <i className="fas fa-angle-double-left"></i>
                                                        </a>
                                                    </li>
                                                    <li className={currentPage === 1 ? "disabled" : ""}>
                                                        <a onClick={() => goToPage(currentPage - 1)} style={{ cursor: "pointer" }}>
                                                            <i className="fas fa-angle-left"></i>
                                                        </a>
                                                    </li>
                                                    {getPageNumbers().map((page) => (
                                                        <li key={page} className={currentPage === page ? "active" : ""}>
                                                            <a onClick={() => goToPage(page)} style={{ cursor: "pointer" }}>{page}</a>
                                                        </li>
                                                    ))}
                                                    <li className={currentPage === totalPages ? "disabled" : ""}>
                                                        <a onClick={() => goToPage(currentPage + 1)} style={{ cursor: "pointer" }}>
                                                            <i className="fas fa-angle-right"></i>
                                                        </a>
                                                    </li>
                                                    <li className={currentPage === totalPages ? "disabled" : ""}>
                                                        <a onClick={() => goToPage(totalPages)} style={{ cursor: "pointer" }}>
                                                            <i className="fas fa-angle-double-right"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </section>
                    </div>
                </Fragment>
            )}
        </Fragment>
    )
}

export default ListContactus;
